import { env } from './Constants';

const MSAL_SCOPES = env.VITE_APP_MSAL_SCOPES
  ? JSON.parse(env.VITE_APP_MSAL_SCOPES)
  : ['https://authviking.onmicrosoft.com/mvj-api/profile.read', 'profile', 'offline_access'];

// Azure AD
const MSAL_CONFIG = Object.freeze({
  auth: {
    authority:
      env.VITE_APP_AZURE_AD_TENANT_URI || 'https://login.microsoftonline.com/3027a973-e4ee-4bca-b8ec-43e5751e2bcf',
    clientId: env.VITE_APP_AZURE_AD_APPLICATION_ID || '054cd7c6-574d-4c9c-b01d-7ae266f89bf9',
    postLogoutRedirectUri: env.VITE_APP_AZURE_DOMAIN || 'https://csadmin.viking.com',
    redirectUri: env.VITE_APP_AZURE_DOMAIN || 'https://csadmin.viking.com',
    scopes: MSAL_SCOPES,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
});

export { MSAL_CONFIG, MSAL_SCOPES };
